import React, { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem('msk_cart');
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('msk_cart', JSON.stringify(items));
  }, [items]);

  // `variant` (optional) is one entry from product.variants: { id, available, price, disponibilite }.
  // When provided (Shopify "Conditions de Livraisons" option), the cart line is keyed by variantId
  // so "En stock" and "Précommande" of the same watch are tracked as separate lines.
  const addItem = (product, qty = 1, variant = null) => {
    const key = variant?.id || product.slug;
    setItems((prev) => {
      const idx = prev.findIndex((p) => (p.variantId || p.slug) === key);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: next[idx].qty + qty };
        return next;
      }
      return [...prev, {
        slug: product.slug,
        variantId: variant?.id || null,
        disponibilite: variant?.disponibilite || null,
        name: product.name,
        price: variant?.price ?? product.price,
        image: product.images[0],
        qty,
      }];
    });
  };

  const removeItem = (key) => setItems((prev) => prev.filter((p) => (p.variantId || p.slug) !== key));
  const updateQty = (key, qty) => setItems((prev) => prev.map((p) => ((p.variantId || p.slug) === key ? { ...p, qty: Math.max(1, qty) } : p)));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.qty * i.price, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, count, total }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
